export const areaData = {
  'Blood_Moor': {
      "en-us": "Blood Moor",
      "zh-tw": "鮮血荒地",
      "zh-cn": "鲜血荒地",
      "de": "Blutmoor",
      "es": "Landa de Sangre",
      "fr": "La Lande sanglante",
      "it": "Lande Insanguinate",
      "ko": "핏빛 황무지",
      "pl": "Krwawe Wrzosowisko",
      "ja": "血の荒野",
      "pt-br": "Charco Sangrento",
      "ru": "Кровавая пустошь"
  },
  'Den_of_Evil': {
      "en-us": "Den of Evil",
      "zh-cn": "邪恶洞穴",
      "zh-tw": "邪惡洞窟",
      "de": "Höhle des Bösen",
      "es": "Cubil del Mal",
      "fr": "Le Repaire du Mal",
      "it": "Antro del Male",
      "ko": "악의 소굴",
      "pl": "Siedlisko Zła",
      "ja": "邪悪の巣窟",
      "pt-br": "Covil do Mal",
      "ru": "Логово зла"
  },
  'Cold_Plains': {
      "en-us": "Cold Plains",
      "zh-cn": "冰冷之原",
      "zh-tw": "冰冷之原",
      "de": "Kalte Ebene",
      "es": "Llanuras Frías",
      "fr": "Les Plaines gelées",
      "it": "Pianure Gelate",
      "ko": "차가운 평야",
      "pl": "Zimna Równina",
      "ja": "荒涼の平原",
      "pt-br": "Planície Gélida",
      "ru": "Стылые равнины"
  },
  'Cave': {
      "en-us": "Cave",
      "zh-cn": "洞穴",
      "zh-tw": "洞窟",
      "de": "Grotte",
      "es": "Cueva",
      "fr": "Grotte",
      "it": "Caverna",
      "ko": "동굴",
      "pl": "Jaskinia",
      "ja": "洞窟",
      "pt-br": "Caverna",
      "ru": "Пещера"
  },
  'Burial_Grounds': {
      "en-us": "Burial Grounds",
      "zh-cn": "埋骨之地",
      "zh-tw": "埋骨之地",
      "de": "Friedhof",
      "es": "Cementerio",
      "fr": "Le Cimetière",
      "it": "Cimitero",
      "ko": "매장지",
      "pl": "Cmentarz",
      "ja": "墓地",
      "pt-br": "Cemitério",
      "ru": "Погост"
  },
  'Crypt': {
      "en-us": "Crypt",
      "zh-cn": "墓穴",
      "zh-tw": "墓地",
      "de": "Krypta",
      "es": "Cripta",
      "fr": "La Crypte",
      "it": "Cripta",
      "ko": "묘실",
      "pl": "Krypta",
      "ja": "地下墓所",
      "pt-br": "Cripta",
      "ru": "Склеп"
  },
  'Mausoleum': {
      "en-us": "Mausoleum",
      "zh-cn": "大陵墓",
      "zh-tw": "大陵寢",
      "de": "Mausoleum",
      "es": "Mausoleo",
      "fr": "Le Mausolée",
      "it": "Mausoleo",
      "ko": "영묘",
      "pl": "Mauzoleum",
      "ja": "霊廟",
      "pt-br": "Mausoléu",
      "ru": "Мавзолей"
  },
  'Stony_Field': {
    'en-us': 'Stony Field',
    'fr': 'Le Champ de pierres',
    'zh-cn': '乱石旷野',
    'zh-tw': '亂石曠野',
    'ko': '바위 벌판',
    'de': 'Feld der Steine',
    'es': 'Campo Pedregoso',
    'ru': 'Каменистое поле',
    'ja': '石の原野',
    'it': 'Campo di Pietra',
    'pl': 'Kamienne Pole',
    'pt-br': 'Campo Rochoso'
  },
  'Tristram': {
    'en-us': 'Tristram',
    'fr': 'Tristram',
    'zh-cn': '崔斯特姆',
    'zh-tw': '崔斯特姆',
    'ko': '트리스트럼',
    'de': 'Tristram',
    'es': 'Tristán',
    'ru': 'Тристрам',
    'ja': 'トリストラム',
    'it': 'Tristram',
    'pl': 'Tristram',
    'pt-br': 'Tristram'
  },
  'Dark_Wood': {
      "en-us": "Dark Wood",
      "zh-cn": "黑暗森林",
      "zh-tw": "黑暗森林",
      "de": "Dunkelwald",
      "es": "Bosque Oscuro",
      "fr": "Le Bois obscur",
      "it": "Foresta Oscura",
      "ko": "어둠숲",
      "pl": "Mroczna Knieja",
      "ja": "常闇の森",
      "pt-br": "Floresta Sombria",
      "ru": "Темнолесье"
  },
  'Underground_Passage': {
      "en-us": "Underground Passage",
      "zh-cn": "地下通道",
      "zh-tw": "地底通道",
      "de": "Unterirdischer Durchgang",
      "es": "Pasadizo Subterráneo",
      "fr": "Passage souterrain",
      "it": "Passaggio Sotterraneo",
      "ko": "지하 통로",
      "pl": "Podziemny Tunel",
      "ja": "地下道",
      "pt-br": "Passagem Subterrânea",
      "ru": "Подземный проход"
  },
  'Black_Marsh': {
      "en-us": "Black Marsh",
      "zh-cn": "黑色荒地",
      "zh-tw": "黑色荒地",
      "de": "Schwarzmoor",
      "es": "Pantano Negro",
      "fr": "Le Marais sombre",
      "it": "Palude Nera",
      "ko": "검은 습지",
      "pl": "Czarne Moczary",
      "ja": "黒の濕原",
      "pt-br": "Charco Tenebroso",
      "ru": "Черная топь"
  },
  'Hole': {
      "en-us": "Hole",
      "zh-cn": "地洞",
      "zh-tw": "洞穴",
      "de": "Loch",
      "es": "Hoyo",
      "fr": "Gouffre",
      "it": "Buco",
      "ko": "구렁",
      "pl": "Jama",
      "ja": "洞穴",
      "pt-br": "Buraco",
      "ru": "Нора"
  },
  'Forgotten_Tower': {
    'en-us': 'The Forgotten Tower',
    'fr': 'La Tour oubliée',
    'zh-cn': '遗忘之塔',
    'zh-tw': '遺忘之塔',
    'ko': '잊힌 탑',
    'de': 'Der Vergessene Turm',
    'es': 'Torre Olvidada',
    'ru': 'Забытая башня',
    'ja': '忘れられし塔',
    'it': 'La Torre Dimenticata',
    'pl': 'Zapomniana Wieża',
    'pt-br': 'A Torre Esquecida'
  },
  'Pit': {
    'en-us': 'The Pit',
    'fr': 'La Fosse',
    'zh-cn': '地穴',
    'zh-tw': '地穴',
    'ko': '구덩이',
    'de': 'Die Grube',
    'es': 'El Foso',
    'ru': 'Яма',
    'ja': '穴ぐら',
    'it': "L'Abisso",
    'pl': 'Czeluść',
    'pt-br': 'O Fosso'
  },
  'Jail': {
      "en-us": "Jail",
      "zh-cn": "监牢",
      "zh-tw": "監牢",
      "de": "Gefängnis",
      "es": "Cárcel",
      "fr": "Prison",
      "it": "Prigione",
      "ko": "감옥",
      "pl": "Więzienie",
      "ja": "牢獄",
      "pt-br": "Prisão",
      "ru": "Тюрьма"
  },
  'Barracks': {
      "en-us": "Barracks",
      "zh-tw": "兵營",
      "zh-cn": "兵营",
      "de": "Kaserne",
      "es": "Barracones",
      "fr": "La Caserne",
      "it": "Caserma",
      "ko": "병영",
      "pl": "Koszary",
      "ja": "兵舎",
      "pt-br": "Quartel",
      "ru": "Казармы"
  },
  'Cathedral': {
      "en-us": "Cathedral",
      "zh-cn": "大教堂",
      "zh-tw": "大教堂",
      "de": "Kathedrale",
      "es": "Catedral",
      "fr": "La Cathédrale",
      "it": "Cattedrale",
      "ko": "대성당",
      "pl": "Katedra",
      "ja": "大聖堂",
      "pt-br": "Catedral",
      "ru": "Собор"
  },
  'Catacombs': {
      "en-us": "Catacombs",
      "zh-cn": "地下墓穴",
      "zh-tw": "地下墓穴",
      "de": "Katakomben",
      "es": "Catacumbas",
      "fr": "Catacombes",
      "it": "Catacombe",
      "ko": "지하 묘지",
      "pl": "Katakumby",
      "ja": "地下墓地",
      "pt-br": "Catacumbas",
      "ru": "Катакомбы"
  },
  'Secret_Cow_Level': {
    'en-us': 'Moo Moo Farm',
    'fr': 'Ferme Meuh-Meuh',
    'zh-cn': '哞哞农场',
    'zh-tw': '哞哞農場',
    'ko': '음메음메 농장',
    'de': 'Muh-Muh-Farm',
    'es': 'Granja Mu Mu',
    'ru': 'Ферма «Му-му»',
    'ja': 'モーモー牧場',
    'it': 'Fattoria Muu Muu',
    'pl': 'Farma Muu Muu',
    'pt-br': 'Fazenda Mu-mu'
  },
  'Lut_Gholein_Sewers': {
    'en-us': 'Lut Gholein Sewers',
    'fr': 'Égouts de Lut Gholein',
    'zh-cn': '鲁高因下水道',
    'zh-tw': '鲁高因下水道',
    'ko': '루트 골레인 하수도',
    'de': 'Kanalisation von Lut Gholein',
    'es': 'Cloacas de Lut Gholein',
    'ru': 'Стоки Лут Голейна',
    'ja': 'ラット・ゴーレインの下水道',
    'it': 'Fogne di Lut Gholein',
    'pl': 'Kanały pod Lut Gholein',
    'pt-br': 'Esgoto de Lut Gholein'
  },
  'Rocky_Waste': {
      "en-us": "Rocky Waste",
      "zh-cn": "碎石荒野",
      "zh-tw": "碎石荒地",
      "de": "Felsige Öde",
      "es": "Erial Rocoso",
      "fr": "Le Désert de roche",
      "it": "Landa Rocciosa",
      "ko": "바위투성이 황무지",
      "pl": "Skalne Pustkowie",
      "ja": "岩だらけの荒れ地",
      "pt-br": "Ermo Rochoso",
      "ru": "Каменистая пустошь"
  },
  'Stony_Tomb': {
      "en-us": "Stony Tomb",
      "zh-cn": "古老石墓",
      "zh-tw": "石制古墓",
      "de": "Steingrab",
      "es": "Tumba Pedregosa",
      "fr": "Le Tombeau de pierre",
      "it": "Tomba di Pietra",
      "ko": "바위 무덤",
      "pl": "Kamienny Grobowiec",
      "ja": "石造りの墓所",
      "pt-br": "Tumba Pétrea",
      "ru": "Каменная гробница"
  },
  'Dry_Hills': {
      "en-us": "Dry Hills",
      "zh-cn": "干燥高地",
      "zh-tw": "乾燥的高地",
      "de": "Verdorrte Hügel",
      "es": "Colinas Áridas",
      "fr": "Les Collines arides",
      "it": "Colline Aride",
      "ko": "메마른 언덕",
      "pl": "Suche Wzgórza",
      "ja": "乾きの丘",
      "pt-br": "Colinas Áridas",
      "ru": "Иссохшие холмы"
  },
  'Halls_of_the_Dead': {
      "en-us": "Halls of the Dead",
      "zh-cn": "死亡之殿",
      "zh-tw": "死亡之殿",
      "de": "Hallen der Toten",
      "es": "Salas de la Muerte",
      "fr": "Les Couloirs des morts",
      "it": "Sale dei Morti",
      "ko": "망자의 전당",
      "pl": "Sale Umarłych",
      "ja": "亡者の広間",
      "pt-br": "Salões dos Mortos",
      "ru": "Чертоги мертвых"
  },
  'Far_Oasis': {
    'en-us': 'Far Oasis',
    'fr': 'L’Oasis lointaine',
    'zh-cn': '遥远的绿洲',
    'zh-tw': '遙遠的綠洲',
    'ko': '머나먼 오아시스',
    'de': 'Ferne Oase',
    'es': 'Oasis Lejano',
    'ru': 'Дальний оазис',
    'ja': '遥かなるオアシス',
    'it': 'Oasi Lontana',
    'pl': 'Daleka Oaza',
    'pt-br': 'Oásis Longínquo'
  },
  'Ancient_Tunnels': {
    'en-us': 'Ancient Tunnels',
    'fr': 'Les Tunnels antiques',
    'zh-cn': '古代通道',
    'zh-tw': '古代通道',
    'ko': '고대 토굴',
    'de': 'Alte Tunnels',
    'es': 'Túneles Antiguos',
    'ru': 'Древние туннели',
    'ja': '古の坑道',
    'it': 'Antichi Tunnel',
    'pl': 'Prastare Tunele',
    'pt-br': 'Túneis Ancestrais'
  },
  'Lost_City': {
      "en-us": "Lost City",
      "zh-cn": "失落古城",
      "zh-tw": "遺失的城市",
      "de": "Vergessene Stadt",
      "es": "Ciudad Perdida",
      "fr": "La Ville oubliée",
      "it": "Città Perduta",
      "ko": "잊힌 도시",
      "pl": "Zaginione Miasto",
      "ja": "失われし都",
      "pt-br": "Cidade Perdida",
      "ru": "Затерянный город"
  },
  'Valley_of_Snakes': {
      "en-us": "Valley of Snakes",
      "zh-cn": "群蛇峡谷",
      "zh-tw": "群蛇峽谷",
      "de": "Tal der Schlangen",
      "es": "Valle de las Serpientes",
      "fr": "La Vallée des serpents",
      "it": "Valle dei Serpenti",
      "ko": "뱀의 골짜기",
      "pl": "Dolina Węży",
      "ja": "蛇の谷",
      "pt-br": "Vale das Cobras",
      "ru": "Долина змей"
  },
  'Claw_Viper_Temple': {
      "en-us": "Claw Viper Temple",
      "zh-cn": "利爪蝮蛇神殿",
      "zh-tw": "利爪腹蛇神殿",
      "de": "Tempel der Klauenvipern",
      "es": "Templo de la Garra Viperina",
      "fr": "Le Temple des Vipères",
      "it": "Tempio delle Vipere",
      "ko": "발톱 독사 사원",
      "pl": "Świątynia Żmijoszponów",
      "ja": "クロウ・ヴァイパーの寺院",
      "pt-br": "Templo da Víbora da Garra",
      "ru": "Храм Когтистого Змея"
  },
  'Arcane_Sanctuary': {
    'en-us': 'Arcane Sanctuary',
    'fr': 'Le Sanctuaire des Arcanes',
    'zh-cn': '秘法圣殿',
    'zh-tw': '秘法聖殿',
    'ko': '비전의 성역',
    'de': 'Geheime Zuflucht',
    'es': 'Santuario Arcano',
    'ru': 'Магическое убежище',
    'ja': '深遠なる聖域',
    'it': 'Santuario Arcano',
    'pl': 'Tajemne Sanktuarium',
    'pt-br': 'Santuário Arcano'
  },
  'Tal_Rashas_Tomb': {
      "en-us": "Tal Rasha's Tomb",
      "zh-cn": "塔·拉夏之墓",
      "zh-tw": "塔·拉夏的古墓",
      "de": "Tal Rashas Grab",
      "es": "Tumba de Tal Rasha",
      "fr": "Le Tombeau de Tal Rasha",
      "it": "Tomba di Tal Rasha",
      "ko": "탈 라샤의 무덤",
      "pl": "Grobowiec Tal Rashy",
      "ja": "タル・ラシャの墓",
      "pt-br": "Tumba de Tal Rasha",
      "ru": "Гробница Тал Раши"
  },
  'Tal_Rashas_Chamber': {
      "en-us": "Tal Rasha's Chamber",
      "zh-cn": "塔拉夏的密室",
      "zh-tw": "都瑞爾的房間",
      "de": "Tal Rashas Kammer",
      "es": "Cámara de Tal Rasha",
      "fr": "La Chambre de Tal Rasha",
      "it": "Cripta di Tal Rasha",
      "ko": "탈 라샤의 방",
      "pl": "Komnata Tal Rashy",
      "ja": "タル・ラシャの間",
      "pt-br": "Câmara de Tal Rasha",
      "ru": "Погребальный зал Тал Раши"
  },
  'Spider_Forest': {
      "en-us": "Spider Forest",
      "zh-cn": "蜘蛛森林",
      "zh-tw": "蜘蛛森林",
      "de": "Spinnenwald",
      "es": "Bosque de Arañas",
      "fr": "La Forêt de l』Araignée",
      "it": "Foresta del Ragno",
      "ko": "거미 숲",
      "pl": "Las Pająków",
      "ja": "蜘蛛の森",
      "pt-br": "Floresta Aracnídea",
      "ru": "Паучий лес"
  },
  'Spider_Cavern': {
      "en-us": "Spider Cavern",
      "zh-cn": "蜘蛛洞窟",
      "zh-tw": "蜘蛛洞窟",
      "de": "Spinnenhöhle",
      "es": "Caverna de Arañas",
      "fr": "La Caverne de l’Araignée",
      "it": "Caverna del Ragno",
      "ko": "거미 동굴",
      "pl": "Grota Pająków",
      "ja": "蜘蛛の洞窟",
      "pt-br": "Caverna Aracnídea",
      "ru": "Паучья пещера"
  },
  'Flayer_Jungle': {
      "en-us": "Flayer Jungle",
      "zh-cn": "剥皮魔丛林",
      "zh-tw": "剝皮叢林",
      "de": "Schinderdschungel",
      "es": "Selva Desolladora",
      "fr": "La Jungle de l』Écorcheur",
      "it": "Giungla Scorticatrice",
      "ko": "약탈자 밀림",
      "pl": "Dżungla Łupieżców",
      "ja": "フレイヤーの密林",
      "pt-br": "Selva dos Esfoladores",
      "ru": "Джунгли свежевателей"
  },
  'Flayer_Dungeon': {
      "en-us": "Flayer Dungeon",
      "zh-cn": "剥皮地牢",
      "zh-tw": "剝皮地窖",
      "de": "Schinderdungeon",
      "es": "Mazmorra de Desollamiento",
      "fr": "La Prison de l』Écorcheur",
      "it": "Sotterraneo Scorticatore",
      "ko": "약탈자 소굴",
      "pl": "Podziemia Łupieżców",
      "ja": "フレイヤーの地下牢",
      "pt-br": "Masmorra dos Esfoladores",
      "ru": "Подземелье свежевателей"
  },
  'Great_Marsh': {
    'en-us': 'Great Marsh',
    'fr': 'Le Grand marais',
    'zh-cn': '大沼泽',
    'zh-tw': '大沼澤',
    'ko': '거대 습지',
    'de': 'Großes Moor',
    'es': 'Gran Pantano',
    'ru': 'Болотина',
    'ja': '大湿原',
    'it': 'Grande Palude',
    'pl': 'Wielkie Moczary',
    'pt-br': 'Grande Charco'
  },
  'Kurast_Bazaar': {
      "en-us": "Kurast Bazaar",
      "zh-cn": "库拉斯特集市",
      "zh-tw": "庫拉斯特商場",
      "de": "Basar von Kurast",
      "es": "Bazar de Kurast",
      "fr": "Le Bazar de Kurast",
      "it": "Bazar di Kurast",
      "ko": "쿠라스트 시장",
      "pl": "Bazar Kurast",
      "ja": "クラスト・バザール",
      "pt-br": "Bazar de Kurast",
      "ru": "Курастский базар"
  },
  'Ruined_Temple': {
      "en-us": "Ruined Temple",
      "zh-cn": "荒废的神殿",
      "zh-tw": "荒廢的神殿",
      "de": "Zerfallener Tempel",
      "es": "Templo en Ruinas",
      "fr": "Le Temple en ruine",
      "it": "Tempio in Rovina",
      "ko": "허물어진 사원",
      "pl": "Zrujnowana Świątynia",
      "ja": "荒れ果てた寺院",
      "pt-br": "Templo Arruinado",
      "ru": "Разрушенный храм"
  },
  'Disused_Fane': {
      "en-us": "Disused Fane",
      "zh-cn": "废弃的寺院",
      "zh-tw": "廢棄的寺院",
      "de": "Verlassenes Heiligtum",
      "es": "Fano Abandonado",
      "fr": "Le Sanctuaire abandonné",
      "it": "Tempio Abbandonato",
      "ko": "버려진 교회당",
      "pl": "Opuszczona Kaplica",
      "ja": "打ち捨てられし神殿",
      "pt-br": "Ádito Abandonado",
      "ru": "Заброшенная церковь"
  },
  'Travincal': {
    'en-us': 'Travincal',
    'fr': 'Travincal',
    'zh-cn': '崔凡克',
    'zh-tw': '崔凡克',
    'ko': '트라빈칼',
    'de': 'Travincal',
    'es': 'Travincal',
    'ru': 'Травинкаль',
    'ja': 'トラヴィンカル',
    'it': 'Travincal',
    'pl': 'Travincal',
    'pt-br': 'Travincal'
  },
  'Durance_of_Hate': {
    'en-us': 'Durance of Hate',
    'fr': 'La Prison de la Haine',
    'zh-cn': '憎恨的囚牢',
    'zh-tw': '憎恨的囚牢',
    'ko': '증오의 억류지',
    'de': 'Kerker des Hasses',
    'es': 'Represión del Odio',
    'ru': 'Узилище ненависти',
    'ja': '憎悪の檻',
    'it': "Prigione dell'Odio",
    'pl': 'Kazamaty Nienawiści',
    'pt-br': 'Cárcere do Ódio'
  },
  'Kurast_Sewers': {
    'en-us': 'Kurast Sewers',
    'fr': 'Égouts de Kurast',
    'zh-cn': '库拉斯特下水道',
    'zh-tw': '庫拉斯特下水道',
    'ko': '쿠라스트 하수도',
    'de': 'Kanalisation von Kurast',
    'es': 'Cloacas de Kurast',
    'ru': 'Курастский Стоки',
    'ja': 'クラストの下水道',
    'it': 'Fogne di Kurast',
    'pl': 'Kanały pod Kurast',
    'pt-br': 'Esgoto de Kurast'
  },
  'Outer_Steppes': {
      "en-us": "Outer Steppes",
      "zh-cn": "外围荒原",
      "zh-tw": "外圍荒原",
      "de": "Äußere Steppe",
      "es": "Estepas Exteriores",
      "fr": "Les Steppes infinies",
      "it": "Steppe Esterne",
      "ko": "평원 외곽",
      "pl": "Zewnętrzne Stepy",
      "ja": "果ての草原",
      "pt-br": "Estepes Externas",
      "ru": "Рубежные степи"
  },
  'Plains_of_Despair': {
      "en-us": "Plains of Despair",
      "zh-cn": "绝望平原",
      "zh-tw": "絕望平原",
      "de": "Ebene der Verzweiflung",
      "es": "Llanuras del Desaliento",
      "fr": "Les Plaines du désespoir",
      "it": "Pianure della Disperazione",
      "ko": "절망의 평원",
      "pl": "Równina Rozpaczy",
      "ja": "絶望の平原",
      "pt-br": "Planície do Desespero",
      "ru": "Долина Отчаяния"
  },
  'River_of_Flame': {
      "en-us": "River of Flame",
      "zh-cn": "火焰之河",
      "zh-tw": "火焰之河",
      "de": "Flammenfluss",
      "es": "Río de Llamas",
      "fr": "La Rivière de feu",
      "it": "Fiume Infuocato",
      "ko": "불길의 강",
      "pl": "Rzeka Płomieni",
      "ja": "炎の河",
      "pt-br": "Rio de Chamas",
      "ru": "Огненная река"
  },
  'City_of_the_Damned': {
      "en-us": "City of the Damned",
      "zh-cn": "神罚之城",
      "zh-tw": "神罰之城",
      "de": "Stadt der Verdammten",
      "es": "Ciudad de los Malditos",
      "fr": "La Ville des damnés",
      "it": "Città Dannata",
      "ko": "저주받은 자들의 도시",
      "pl": "Miasto Potępionych",
      "ja": "呪われし街",
      "pt-br": "Cidade dos Condenados",
      "ru": "Город Проклятых"
  },
  'Chaos_Sanctuary': {
    'en-us': 'Chaos Sanctuary',
    'fr': 'Le Sanctuaire du chaos',
    'zh-cn': '混沌避难所',
    'zh-tw': '混沌庇難所',
    'ko': '혼돈의 성역',
    'de': 'Chaossanktuarium',
    'es': 'Santuario del Caos',
    'ru': 'Святилище Хаоса',
    'ja': '混沌の聖域',
    'it': 'Santuario del Caos',
    'pl': 'Sanktuarium Chaosu',
    'pt-br': 'Santuário do Caos'
  },
  'Bloody_Foothills': {
      "en-us": "Bloody Foothills",
      "zh-cn": "血腥丘陵",
      "zh-tw": "血腥丘陵",
      "de": "Blutiges Vorgebirge",
      "es": "Estribaciones Sangrientas",
      "fr": "Les Collines Sanglantes",
      "it": "Colline Insanguinate",
      "ko": "핏빛 언덕",
      "pl": "Krwawe Wzgórza",
      "ja": "血に塗れし丘陵",
      "pt-br": "Colinas Sangrentas",
      "ru": "Кровавые предгорья"
  },
  'Frigid_Highlands': {
      "en-us": "Frigid Highlands",
      "zh-cn": "冰冻高地",
      "zh-tw": "冰凍高地",
      "de": "Eishochland",
      "es": "Tierras Altas Glaciales",
      "fr": "Les Hautes-Glaces",
      "it": "Altopiani del Gelo",
      "ko": "혹한의 고산지",
      "pl": "Zlodowaciała Wyżyna",
      "ja": "極寒の高原",
      "pt-br": "Terras Altas Gélidas",
      "ru": "Мерзлое нагорье"
  },
  'Abaddon': {
      "en-us": "Abaddon",
      "zh-cn": "亚巴顿",
      "zh-tw": "亞巴頓",
      "de": "Abaddon",
      "es": "Abaddon",
      "fr": "Abaddon",
      "it": "Abaddon",
      "ko": "나락",
      "pl": "Abaddon",
      "ja": "奈落",
      "pt-br": "Abadom",
      "ru": "Аваддон"
  },
  'Glacial_Trail': {
      "en-us": "Glacial Trail",
      "zh-cn": "冰川小径",
      "zh-tw": "冰河小徑",
      "de": "Gletscherweg",
      "es": "Senda Glacial",
      "fr": "La Piste des Glaces",
      "it": "Sentiero Ghiacciato",
      "ko": "빙하의 길",
      "pl": "Lodowy Trakt",
      "ja": "氷の道",
      "pt-br": "Trilha Glacial",
      "ru": "Ледовый ход"
  },
  'Drifter_Cavern': {
      "en-us": "Drifter Cavern",
      "zh-cn": "漂泊者洞窟",
      "zh-tw": "漂泊者洞穴",
      "de": "Flockenhöhle",
      "es": "Caverna del Errante",
      "fr": "La Caverne du Yéti",
      "it": "Caverna dei Viandanti",
      "ko": "부랑자의 동굴",
      "pl": "Grota Tułaczy",
      "ja": "流れ者の洞窟",
      "pt-br": "Caverna do Errante",
      "ru": "Пещера скитальцев"
  },
  'Ancients_Way': {
      "en-us": "The Ancients' Way",
      "zh-cn": "先祖之路",
      "zh-tw": "遠古之路",
      "de": "Der Weg der Urahnen",
      "es": "Camino de los Antiguos",
      "fr": "Le Chemin des Anciens",
      "it": "Via degli Antichi",
      "ko": "고대인의 길",
      "pl": "Droga Starożytnych",
      "esMX": "El Camino de los Ancestros",
      "ja": "古の民の通り道",
      "pt-br": "Caminho dos Ancestrais",
      "ru": "Путь Древних"
  },
  'Icy_Cellar': {
      "en-us": "Icy Cellar",
      "zh-cn": "冰窖",
      "zh-tw": "冰窖",
      "de": "Eiskeller",
      "es": "Sótano Helado",
      "fr": "La Cave Glaciale",
      "it": "Sotterraneo di Ghiaccio",
      "ko": "얼음 지하실",
      "pl": "Lodowa Piwnica",
      "ja": "氷の穴ぐら",
      "pt-br": "Porão Gélido",
      "ru": "Ледяной грот"
  },
  'Arreat_Plateau': {
      "en-us": "Arreat Plateau",
      "zh-cn": "亚瑞特高原",
      "zh-tw": "亞瑞特高原",
      "de": "Arreathochebene",
      "es": "Meseta Arreat",
      "fr": "Le Mont Arreat",
      "it": "Plateau dell'Arreat",
      "ko": "아리앗 고원",
      "pl": "Płaskowyż Arreat",
      "ja": "アリート高地",
      "pt-br": "Platô de Arreat",
      "ru": "Арреатское плато"
  },
  'Pit_of_Acheron': {
      "en-us": "Pit of Acheron",
      "zh-cn": "冥河地穴",
      "zh-tw": "冥河之洞",
      "de": "Grube von Acheron",
      "es": "Foso de Acheron",
      "fr": "Puits d』Acheron",
      "it": "Abisso dell'Acheronte",
      "ko": "아케론의 구덩이",
      "pl": "Otchłań Acheronu",
      "ja": "冥穴",
      "pt-br": "Fosso de Aqueron",
      "ru": "Пропасть Ахерона"
  },
  'Crystalline_Passage': {
      "en-us": "Crystalline Passage",
      "zh-cn": "水晶通道",
      "zh-tw": "水晶通道",
      "de": "Kristalldurchgang",
      "es": "Pasaje Cristalino",
      "fr": "Le Passage Cristallin",
      "it": "Passaggio Cristallino",
      "ko": "수정 동굴",
      "pl": "Kryształowe Przejście",
      "ja": "結晶道",
      "pt-br": "Passagem Cristalina",
      "ru": "Ледяные пещеры"
  },
  'Frozen_River': {
      "en-us": "Frozen River",
      "zh-cn": "冰冻之河",
      "zh-tw": "冰凍之河",
      "de": "Frostfluss",
      "es": "Río Helado",
      "fr": "La Rivière Glacée",
      "it": "Fiume Gelido",
      "ko": "얼어붙은 강",
      "pl": "Zamarznięta Rzeka",
      "ja": "凍てつく川",
      "pt-br": "Rio Congelado",
      "ru": "Замерзшая река"
  },
  'Nihlathaks_Temple': {
      "en-us": "Nihlathak's Temple",
      "zh-cn": "尼拉塞克的神殿",
      "zh-tw": "尼拉塞克的神殿",
      "de": "Nihlathaks Tempel",
      "es": "Templo de Nihlathak",
      "fr": "Le Temple de Nihlathak",
      "it": "Tempio di Nihlathak",
      "ko": "니흘라탁의 사원",
      "pl": "Świątynia Nihlathaka",
      "ja": "ニーラサックの寺院",
      "pt-br": "Templo de Nilatak",
      "ru": "Храм Нильятака"
  },
  'Halls_of_Anguish': {
      "en-us": "Halls of Anguish",
      "zh-cn": "怨恸之厅",
      "zh-tw": "怨慟之廳",
      "de": "Hallen der Qual",
      "es": "Salas de la Angustia",
      "fr": "Les Corridors de l』Angoisse",
      "it": "Sale dell'Angoscia",
      "ko": "고뇌의 전당",
      "pl": "Sale Cierpienia",
      "ja": "苦悶の広間",
      "pt-br": "Salões da Angústia",
      "ru": "Чертоги Мучений"
  },
  'Halls_of_Pain': {
      "en-us": "Halls of Pain",
      "zh-cn": "苦痛之厅",
      "zh-tw": "苦痛之廳",
      "de": "Hallen der Schmerzen",
      "es": "Salas del Dolor",
      "fr": "Les Corridors de la Souffrance",
      "it": "Sale del Dolore",
      "ko": "고통의 전당",
      "pl": "Sale Bólu",
      "ja": "苦痛の広間",
      "pt-br": "Salões da Dor",
      "ru": "Чертоги Боли"
  },
  'Halls_of_Vaught': {
      "en-us": "Halls of Vaught",
      "zh-cn": "沃特之厅",
      "zh-tw": "沃特之廳",
      "de": "Hallen von Vaught",
      "es": "Salas de Vaught",
      "fr": "Les Corridors du Martyre",
      "it": "Sale di Vaught",
      "ko": "보트의 전당",
      "pl": "Sale Nieszczęścia",
      "ja": "ヴォートの広間",
      "pt-br": "Salões de Vaught",
      "ru": "Чертоги Воута"
  },
  'Worldstone_Keep': {
      "en-us": "Worldstone Keep",
      "zh-cn": "世界之石要塞",
      "zh-tw": "世界之石要塞",
      "de": "Weltsteinturm",
      "es": "Torre de la Piedra del Mundo",
      "fr": "Donjon de la Pierre-Monde",
      "it": "Forte della Pietra del Mondo",
      "ko": "세계석 성채",
      "pl": "Twierdza Kamienia Świata",
      "ja": "ワールドストーン城塞",
      "pt-br": "Forte da Pedra do Mundo",
      "ru": "Крепость камня мироздания"
  },
  'Throne_of_Destruction': {
      "en-us": "Throne of Destruction",
      "zh-cn": "毁灭王座",
      "zh-tw": "毀滅王座",
      "de": "Thron der Zerstörung",
      "es": "Trono de la Destrucción",
      "fr": "Le Trône de la Destruction",
      "it": "Trono della Distruzione",
      "ko": "파괴의 왕좌",
      "pl": "Tron Zniszczenia",
      "ja": "破壊の玉座",
      "pt-br": "Trono da Destruição",
      "ru": "Престол Разрушения"
  },
  'Worldstone_Chamber': {
      "en-us": "Worldstone Chamber",
      "zh-cn": "世界之石大殿",
      "zh-tw": "世界之石大殿",
      "de": "Die Kammer des Weltsteins",
      "es": "Cámara de la Piedra del Mundo",
      "fr": "La Chambre de la Pierre-Monde",
      "it": "Sale della Pietra del Mondo",
      "ko": "세계석 보관실",
      "pl": "Komnata Kamienia Świata",
      "ja": "ワールドストーンの間",
      "pt-br": "Câmara da Pedra do Mundo",
      "ru": "Святилище Мироздания"
  },
}
